import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const FooterWidget = () => {
    return (_jsxs("footer", { className: "site-footer", children: [_jsxs("p", { children: ["\u00A9 ", new Date().getFullYear(), " Dr. Christopher L. Pecsok, DC. All rights reserved."] }), _jsxs("p", { children: ["Powered by ", _jsx("a", { href: "https://www.junsoft.de", children: "Junsoft Solutions" })] })] }));
};
export default FooterWidget;
